import {
	Component, OnInit, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MonitorPolicy, MonitorSettings_Ping } from 'DiscoveryEngine.TS/Monitors';
import { MonitorConfigComponentBase } from '../MonitorConfigComponentBase';


@Component({
	selector: 'ping-settings',
	templateUrl: './pingsettings.component.html',
	styleUrls: ['./pingsettings.component.scss']
})
export class PingSettingsComponent extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

	public name: UntypedFormControl;
	public enabled: UntypedFormControl;
	public responseTests: UntypedFormControl;
	public checkUpTime: UntypedFormControl;
	public timeout: UntypedFormControl;
	public retries: UntypedFormControl;
	public useThresholds: UntypedFormControl;
	public criticalThreshold: UntypedFormControl;
	public warningThreshold: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public ngOnDestroy(): void {
		return;
	}

	public BuildForm(): void {
		let name = "";
		let enabled = false;
		let responseTests = "0";
		let checkUpTime = false;
		let timeout = 0;
		let retries = 0;
		let useThresholds = false;
		let criticalThreshold = 0;
		let warningThreshold = 0;

		if (!!this.editor && this.editor.HasPolicy) {
			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_Ping = <MonitorSettings_Ping>monPolicy.Settings;

			name = monPolicy.Name;
			enabled = monPolicy.Enabled;
			responseTests = monSettings.ResponseChecks + "";
			checkUpTime = monSettings.CheckUpTime;
			timeout = monSettings.Timeout;
			retries = monSettings.Retries;
			useThresholds = monSettings.UseThresholds;
			criticalThreshold = monSettings.CriticalThreshold;
			warningThreshold = monSettings.WarningThreshold;
		}

		this.name = new UntypedFormControl(name, Validators.required);
		this.enabled = new UntypedFormControl(enabled);
		this.responseTests = new UntypedFormControl(responseTests);
		this.checkUpTime = new UntypedFormControl(checkUpTime);
		this.timeout = new UntypedFormControl(timeout, Validators.compose([Validators.required, this.minValue(250), this.maxValue(25000)]));
		this.retries = new UntypedFormControl(retries, Validators.compose([Validators.required, this.minValue(0), this.maxValue(10)]));
		this.useThresholds = new UntypedFormControl(useThresholds);
		this.criticalThreshold = new UntypedFormControl(criticalThreshold, Validators.compose([Validators.required, this.minValue(100), this.maxValue(1000000)]));
		this.warningThreshold = new UntypedFormControl(warningThreshold, Validators.compose([Validators.required, this.minValue(0), this.maxValue(1000000)]));

		this.enableDisableControls();

		this.SettingsForm = this.fb.group({
			name: this.name,
			enabled: this.enabled,
			responseTests: this.responseTests,
			checkUpTime: this.checkUpTime,
			timeout: this.timeout,
			retries: this.retries,
			useThresholds: this.useThresholds,
			criticalThreshold: this.criticalThreshold,
			warningThreshold: this.warningThreshold,
		});
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.checkUpTime, this.checkUpTimeEnabled);
		this.enableDisableFormControl(this.criticalThreshold, this.thresholdsEnabled);
		this.enableDisableFormControl(this.warningThreshold, this.thresholdsEnabled);
	}

	public get checkUpTimeEnabled(): boolean {
		return (this.responseTests.value !== "0");
	}

	public get thresholdsEnabled(): boolean {
		return (this.useThresholds.value === true);
	}

	public applyTempChanges(): void {
		if (!!this.editor && this.editor.HasPolicy) {

			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_Ping = <MonitorSettings_Ping>monPolicy.Settings;

			monPolicy.Name = this.name.value;
			monPolicy.Enabled = this.enabled.value;
			monSettings.ResponseChecks = parseInt(this.responseTests.value);
			monSettings.CheckUpTime = this.checkUpTime.value;
			monSettings.Timeout = this.timeout.value;
			monSettings.Retries = this.retries.value;
			monSettings.UseThresholds = this.useThresholds.value;
			monSettings.CriticalThreshold = this.criticalThreshold.value;
			monSettings.WarningThreshold = this.warningThreshold.value;

			this.BuildForm();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Settings"];
	}
}
